import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-12 lg:col-4" }
const _hoisted_5 = {
  key: 0,
  class: "card"
}
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = {
  key: 1,
  class: "card"
}
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = { class: "col-12 lg:col-4" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "p-fluid" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("🎲")
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "p-fluid" }
const _hoisted_21 = {
  key: 0,
  class: "card"
}
const _hoisted_22 = { class: "label block mb-2" }
const _hoisted_23 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_24 = { class: "mr-1 text-xs api-token" }
const _hoisted_25 = { class: "col-12 lg:col-4" }
const _hoisted_26 = { class: "card" }
const _hoisted_27 = { class: "p-fluid" }
const _hoisted_28 = { class: "p-fluid" }
const _hoisted_29 = {
  key: 1,
  class: "card"
}
const _hoisted_30 = { class: "p-fluid" }
const _hoisted_31 = { class: "card" }
const _hoisted_32 = { class: "p-fluid" }
const _hoisted_33 = { class: "card" }
const _hoisted_34 = {
  key: 2,
  class: "card"
}
const _hoisted_35 = { class: "p-fluid" }
const _hoisted_36 = {
  key: 3,
  class: "card operations"
}
const _hoisted_37 = { class: "mb-5" }
const _hoisted_38 = { class: "grid mx-0 px-2 py-2 surface-300 border-round-lg" }
const _hoisted_39 = { class: "col-12 lg:col-2" }
const _hoisted_40 = { class: "font-semibold mb-2" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "col-12 lg:col-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-2" }, "IP", -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "col-12 lg:col-2" }
const _hoisted_48 = { class: "font-semibold mb-2" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "col-12 lg:col-6" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-2" }, "User Agent", -1)
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "grid" }
const _hoisted_56 = { class: "col-12 lg:col-2" }
const _hoisted_57 = { class: "font-semibold mb-2" }
const _hoisted_58 = { class: "col-12 lg:col-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-2" }, "IP", -1)
const _hoisted_60 = { class: "col-12 lg:col-2" }
const _hoisted_61 = { class: "font-semibold mb-2" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "col-12 lg:col-6" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-2" }, "User Agent", -1)
const _hoisted_66 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _component_UserContactInformation = _resolveComponent("UserContactInformation")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PublisherPayoutInformation = _resolveComponent("PublisherPayoutInformation")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_FieldCheckbox = _resolveComponent("FieldCheckbox")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_IconPark = _resolveComponent("IconPark")!
  const _component_UiSettings = _resolveComponent("UiSettings")!
  const _component_Balance = _resolveComponent("Balance")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_Entry = _resolveComponent("Entry")!
  const _component_Endpoints = _resolveComponent("Endpoints")!
  const _component_Payouts = _resolveComponent("Payouts")!
  const _component_Campaigns = _resolveComponent("Campaigns")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Entry, {
      class: "mb-4",
      "entry-errors-map": _ctx.userErrorsMap,
      "onUpdate:entry-errors-map": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.userErrorsMap) = $event)),
      title: _ctx.$t('user'),
      entry: _ctx.user,
      "entry-fetch-handler": _ctx.fetchUser,
      "entry-store-handler": _ctx.storeUser
    }, {
      "buttons-col-1-append": _withCtx(() => [
        _createVNode(_component_PrimeVueButton, {
          class: "p-button-secondary ml-4 mb-0",
          label: _ctx.$t('copy_login_url'),
          icon: "pi pi-key",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getLoginURL(_ctx.data)))
        }, null, 8, ["label"])
      ]),
      "buttons-col-2-prepend": _withCtx(() => [
        _createElementVNode("a", {
          class: "ml-4",
          href: `/statistics/staff?filters=${_ctx.encodeStatisticsFilters({ publisher_id: [_ctx.user.id] })}`,
          target: "_blank"
        }, [
          _createVNode(_component_PrimeVueButton, {
            class: "p-button-info mb-0",
            label: _ctx.$t('publisher_statistics'),
            icon: "pi pi-chart-bar"
          }, null, 8, ["label"])
        ], 8, _hoisted_1),
        _createElementVNode("a", {
          class: "ml-4",
          href: `/statistics/staff?filters=${_ctx.encodeStatisticsFilters({ advertiser_id: [_ctx.user.id] })}`,
          target: "_blank"
        }, [
          _createVNode(_component_PrimeVueButton, {
            class: "p-button-info mb-0",
            label: _ctx.$t('advertiser_statistics'),
            icon: "pi pi-chart-bar"
          }, null, 8, ["label"])
        ], 8, _hoisted_2)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!!_ctx.user.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.user.id,
                      label: "ID",
                      disabled: ""
                    }, null, 8, ["model-value"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeUser.isSuperAdmin())
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_FieldDropdown, {
                      modelValue: _ctx.user.project_id,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.project_id) = $event)),
                        _ctx.onProjectChange
                      ],
                      modelModifiers: { number: true },
                      name: "project_id",
                      "errors-map": _ctx.userErrorsMap,
                      label: _ctx.$t('project'),
                      loading: _ctx.projectsLoading,
                      disabled: !!_ctx.user.id,
                      options: _ctx.projects.data,
                      "option-value": "id",
                      "option-label": "name",
                      "option-label-translate": false
                    }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_FieldDropdown, {
                  modelValue: _ctx.user.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.type) = $event)),
                  modelModifiers: { number: true },
                  name: "type",
                  "errors-map": _ctx.userErrorsMap,
                  label: _ctx.$t('type'),
                  disabled: !!_ctx.user.id,
                  options: _ctx.userTypes
                }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_FieldText, {
                  modelValue: _ctx.user.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.email) = $event)),
                  modelModifiers: { trim: true },
                  name: "email",
                  "errors-map": _ctx.userErrorsMap,
                  label: _ctx.$t('email'),
                  disabled: !!_ctx.user.id
                }, null, 8, ["modelValue", "errors-map", "label", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_FieldText, {
                  modelValue: _ctx.user.alias,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.alias) = $event)),
                  modelModifiers: { trim: true },
                  name: "alias",
                  "errors-map": _ctx.userErrorsMap,
                  label: _ctx.$t('alias')
                }, null, 8, ["modelValue", "errors-map", "label"])
              ])
            ]),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_UserContactInformation, {
                  modelValue: _ctx.user,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user) = $event)),
                  "errors-map": _ctx.userErrorsMap
                }, null, 8, ["modelValue", "errors-map"])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueColumn, { height: "10px" })
              ]),
              _: 1
            })),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_PublisherPayoutInformation, {
                  modelValue: _ctx.user,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user) = $event)),
                  "errors-map": _ctx.userErrorsMap
                }, null, 8, ["modelValue", "errors-map"])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
              ]),
              _: 1
            }))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FieldText, {
                  modelValue: _ctx.user.password,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.password) = $event)),
                  modelModifiers: { trim: true },
                  name: "password",
                  "errors-map": _ctx.userErrorsMap,
                  label: _ctx.$t('new_password'),
                  "input-group": true
                }, {
                  append: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_PrimeVueButton, {
                      class: "p-button-secondary",
                      onClick: _ctx.generatePassword
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [
                        _directive_tooltip,
                        _ctx.$t('generate_password'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "errors-map", "label"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_FieldCheckbox, {
                  modelValue: _ctx.user.enable_pay_by_card,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.enable_pay_by_card) = $event)),
                  label: _ctx.$t('enable_pay_by_card')
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_FieldCheckbox, {
                  modelValue: _ctx.user.auto_approve_campaigns,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.auto_approve_campaigns) = $event)),
                  label: _ctx.$t('auto_approve_campaings')
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.user.max_sites,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.user.max_sites) = $event)),
                  modelModifiers: { number: true },
                  name: "max_sites",
                  "errors-map": _ctx.userErrorsMap,
                  label: _ctx.$t('max_sites'),
                  min: 0,
                  step: 1,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus"
                }, null, 8, ["modelValue", "errors-map", "label"]),
                _createVNode(_component_FieldCheckbox, {
                  modelValue: _ctx.user.show_bounces,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.show_bounces) = $event)),
                  label: _ctx.$t('show_bounces')
                }, null, 8, ["modelValue", "label"])
              ])
            ]),
            (!!_ctx.user.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('api_token')), 1),
                  (_ctx.user.api_token)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("code", _hoisted_24, _toDisplayString(_ctx.user.api_token), 1),
                        _createVNode(_component_IconPark, {
                          class: "cursor-pointer",
                          type: "copy",
                          theme: "outline",
                          size: "11",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.copyToClipboard(_ctx.user.api_token)))
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_PrimeVueButton, {
                    class: "p-button-secondary w-full",
                    label: _ctx.$t('generate'),
                    icon: "pi pi-key",
                    loading: _ctx.generateApiTokenLoading,
                    onClick: _ctx.generateApiToken
                  }, null, 8, ["label", "loading", "onClick"])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_UiSettings, {
                  modelValue: _ctx.user,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.user) = $event))
                }, null, 8, ["modelValue"])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
              ]),
              _: 1
            }))
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.user.balance_overdraft,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.user.balance_overdraft) = $event)),
                  modelModifiers: { number: true },
                  name: "balance_overdraft",
                  "errors-map": _ctx.userErrorsMap,
                  label: _ctx.$t('balance_overdraft'),
                  min: 0,
                  step: 5,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus",
                  prefix: "$"
                }, null, 8, ["modelValue", "errors-map", "label"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.user.default_revshare_advertiser,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.user.default_revshare_advertiser) = $event)),
                  modelModifiers: { number: true },
                  name: "default_revshare_advertiser",
                  "errors-map": _ctx.userErrorsMap,
                  label: _ctx.$t('default_revshare_advertiser'),
                  min: 0,
                  max: 200,
                  step: 5,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus",
                  suffix: "%"
                }, null, 8, ["modelValue", "errors-map", "label"])
              ])
            ]),
            (!!_ctx.user.id)
              ? (_openBlock(), _createBlock(_Suspense, {
                  key: 0,
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Balance, {
                      "user-id": _ctx.user.id,
                      "user-balance": _ctx.user.balance,
                      "onUpdate:user-balance": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.user.balance) = $event))
                    }, null, 8, ["user-id", "user-balance"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueColumn, { height: "10px" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.user.type === _ctx.USER_TYPE_AFFILIATE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_FieldDropdown, {
                      modelValue: _ctx.user.manager_id,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.user.manager_id) = $event)),
                      modelModifiers: { number: true },
                      name: "manager_id",
                      "errors-map": _ctx.userErrorsMap,
                      label: _ctx.$t('manager'),
                      loading: _ctx.managersLoading,
                      "show-clear": true,
                      options: _ctx.managers.data,
                      "option-value": "id",
                      "option-label": "email",
                      "option-label-translate": false
                    }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_FieldDropdown, {
                  modelValue: _ctx.user.status,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.user.status) = $event)),
                  modelModifiers: { number: true },
                  name: "status",
                  "errors-map": _ctx.userErrorsMap,
                  label: _ctx.$t('status'),
                  options: _ctx.USER_STATUSES
                }, null, 8, ["modelValue", "errors-map", "label", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_FieldTextarea, {
                modelValue: _ctx.user.comment,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.user.comment) = $event)),
                modelModifiers: { trim: true },
                name: "comment",
                "errors-map": _ctx.userErrorsMap,
                label: _ctx.$t('comment')
              }, null, 8, ["modelValue", "errors-map", "label"])
            ]),
            (!!_ctx.user.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.user.created_at,
                      label: _ctx.$t('created_at'),
                      disabled: ""
                    }, null, 8, ["model-value", "label"]),
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.user.updated_at,
                      label: _ctx.$t('updated_at'),
                      disabled: ""
                    }, null, 8, ["model-value", "label"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["entry-errors-map", "title", "entry", "entry-fetch-handler", "entry-store-handler"]),
    (!!_ctx.user.id)
      ? (_openBlock(), _createBlock(_Suspense, {
          key: 0,
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Endpoints, {
              filters: { user_id: _ctx.user.id },
              "show-project-column": false,
              "show-user-column": false
            }, null, 8, ["filters"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_PrimeVueColumn, { height: "10px" })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!!_ctx.user.id)
      ? (_openBlock(), _createBlock(_Suspense, {
          key: 1,
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Payouts, {
              filters: { user_id: _ctx.user.id },
              "show-terms": false,
              "show-project-column": false,
              "show-user-column": false
            }, null, 8, ["filters"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_PrimeVueColumn, { height: "10px" })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!!_ctx.user.id)
      ? (_openBlock(), _createBlock(_Suspense, {
          key: 2,
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Campaigns, {
              filters: { user_id: _ctx.user.id },
              "show-project-column": false,
              "show-user-column": false
            }, null, 8, ["filters"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_PrimeVueColumn, { height: "10px" })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!!_ctx.user.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("h1", _hoisted_37, _toDisplayString(_ctx.$t('authorizations')), 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('signup_at')), 1),
              (_ctx.user.created_at)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.user.created_at), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_42, "—"))
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              (_ctx.user.signup_ip)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.user.signup_ip), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_46, "—"))
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('country')), 1),
              (_ctx.user.signup_country_alpha2_code)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.user.signup_country_alpha2_code), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_50, "—"))
            ]),
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              (_ctx.user.signup_user_agent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.user.signup_user_agent), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_54, "—"))
            ])
          ]),
          (_ctx.authorizations)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.authorizations, (authorization, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "insights",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('login_at')), 1),
                      _createElementVNode("div", null, _toDisplayString(authorization.login_at), 1)
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", null, _toDisplayString(authorization.ip), 1)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('country')), 1),
                      (authorization.country_alpha2_code)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(authorization.country_alpha2_code), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_63, "—"))
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _hoisted_65,
                      _createElementVNode("div", null, _toDisplayString(authorization.user_agent), 1)
                    ])
                  ])
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.$t('nothing')), 1))
        ]))
      : (_openBlock(), _createBlock(_component_PrimeVueColumn, {
          key: 4,
          height: "10px"
        }))
  ], 64))
}